import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { buildFacetDesignOverride } from 'Packages/FacetRest/FacetDesignOverride';
import { overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverrideLite';
import { FDHeadlineText } from '@facet-wealth/design';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import Content from './Content';

const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => FDHeadlineText,
    _customProps: {
      size: 'lg',
      color: 'textSecondary',
    },
  }, overrideReadOnly)
  .done();

const Layout = () => {
  const { resource } = useMetaLayoutContext();

  if (!resource) {
    return null;
  }

  return (
    <MetaResourceRenderer
      resource={resource}
      layout={Content}
      metaOverrideSet={metaOverrideSet}
    />
  );
};

export default Layout;
